module.exports = __webpack_public_path__ + "static/img/icon-title-land.927dc219.svg";